import _asyncToGenerator from "/www/wwwroot/shishai_admin_fe/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";

//
//
//
//
//
//
//
//
//
var version = require('element-ui/package.json').version; // element-ui version from node_modules


var ORIGINAL_THEME = '#409EFF'; // default color

export default {
  data: function data() {
    return {
      chalk: '',
      // content of theme-chalk css
      theme: ''
    };
  },
  computed: {
    defaultTheme: function defaultTheme() {
      return this.$store.state.settings.theme;
    }
  },
  watch: {
    defaultTheme: {
      handler: function handler(val, oldVal) {
        this.theme = val;
      },
      immediate: true
    },
    theme: function theme(val) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var oldVal, themeCluster, originalCluster, $message, getHandler, url, chalkHandler, styles;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                oldVal = _this.chalk ? _this.theme : ORIGINAL_THEME;

                if (!(typeof val !== 'string')) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                themeCluster = _this.getThemeCluster(val.replace('#', ''));
                originalCluster = _this.getThemeCluster(oldVal.replace('#', ''));
                console.log(themeCluster, originalCluster);
                $message = _this.$message({
                  message: '  Compiling the theme',
                  customClass: 'theme-message',
                  type: 'success',
                  duration: 0,
                  iconClass: 'el-icon-loading'
                });

                getHandler = function getHandler(variable, id) {
                  return function () {
                    var originalCluster = _this.getThemeCluster(ORIGINAL_THEME.replace('#', ''));

                    var newStyle = _this.updateStyle(_this[variable], originalCluster, themeCluster);

                    var styleTag = document.getElementById(id);

                    if (!styleTag) {
                      styleTag = document.createElement('style');
                      styleTag.setAttribute('id', id);
                      document.head.appendChild(styleTag);
                    }

                    styleTag.innerText = newStyle;
                  };
                };

                if (_this.chalk) {
                  _context.next = 12;
                  break;
                }

                url = "https://unpkg.com/element-ui@".concat(version, "/lib/theme-chalk/index.css");
                _context.next = 12;
                return _this.getCSSString(url, 'chalk');

              case 12:
                chalkHandler = getHandler('chalk', 'chalk-style');
                chalkHandler();
                styles = [].slice.call(document.querySelectorAll('style')).filter(function (style) {
                  var text = style.innerText;
                  return new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text);
                });
                styles.forEach(function (style) {
                  var innerText = style.innerText;
                  if (typeof innerText !== 'string') return;
                  style.innerText = _this.updateStyle(innerText, originalCluster, themeCluster);
                });

                _this.$emit('change', val);

                $message.close();

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  methods: {
    updateStyle: function updateStyle(style, oldCluster, newCluster) {
      var newStyle = style;
      oldCluster.forEach(function (color, index) {
        newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index]);
      });
      return newStyle;
    },
    getCSSString: function getCSSString(url, variable) {
      var _this2 = this;

      return new Promise(function (resolve) {
        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            _this2[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, '');
            resolve();
          }
        };

        xhr.open('GET', url);
        xhr.send();
      });
    },
    getThemeCluster: function getThemeCluster(theme) {
      var tintColor = function tintColor(color, tint) {
        var red = parseInt(color.slice(0, 2), 16);
        var green = parseInt(color.slice(2, 4), 16);
        var blue = parseInt(color.slice(4, 6), 16);

        if (tint === 0) {
          // when primary color is in its rgb space
          return [red, green, blue].join(',');
        } else {
          red += Math.round(tint * (255 - red));
          green += Math.round(tint * (255 - green));
          blue += Math.round(tint * (255 - blue));
          red = red.toString(16);
          green = green.toString(16);
          blue = blue.toString(16);
          return "#".concat(red).concat(green).concat(blue);
        }
      };

      var shadeColor = function shadeColor(color, shade) {
        var red = parseInt(color.slice(0, 2), 16);
        var green = parseInt(color.slice(2, 4), 16);
        var blue = parseInt(color.slice(4, 6), 16);
        red = Math.round((1 - shade) * red);
        green = Math.round((1 - shade) * green);
        blue = Math.round((1 - shade) * blue);
        red = red.toString(16);
        green = green.toString(16);
        blue = blue.toString(16);
        return "#".concat(red).concat(green).concat(blue);
      };

      var clusters = [theme];

      for (var i = 0; i <= 9; i++) {
        clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
      }

      clusters.push(shadeColor(theme, 0.1));
      return clusters;
    }
  }
};